<ng-container *ngIf="isUserLoggedIn; else notLoggedIn">
<div class="card-body">
    <div id="showcaseTalkjsContainerMobile" class="card-body">
      <div>
        <div id="talkjs-container-mobile" style="width: 100%; height: 800px"></div>
      </div>
    </div>
</div>
</ng-container>

<ng-template #notLoggedIn>
  <div class="not-loggedin-card">
    <p class="custom-info"> Please
    <span class="router-link" (click)="onUserNotLoggedIn()">Log in</span> to access the chat.
    </p>
  </div>

  </ng-template>